import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import getNavigationActionCreators from './routers/getNavigationActionCreators';
import _getChildNavigation from './getChildNavigation';
import getChildrenNavigationCache from './getChildrenNavigationCache';
export default function getNavigation(router, state, dispatch, actionSubscribers, getScreenProps, getCurrentNavigation) {
  var actions = router.getActionCreators(state, null);
  var navigation = {
    actions: actions,
    router: router,
    state: state,
    dispatch: dispatch,
    getScreenProps: getScreenProps,
    getChildNavigation: function getChildNavigation(childKey) {
      return _getChildNavigation(navigation, childKey, getCurrentNavigation);
    },
    isFocused: function isFocused(childKey) {
      var _getCurrentNavigation = getCurrentNavigation().state,
          routes = _getCurrentNavigation.routes,
          index = _getCurrentNavigation.index;

      if (childKey == null || routes[index].key === childKey) {
        return true;
      }

      return false;
    },
    addListener: function addListener(eventName, handler) {
      if (eventName !== 'action') {
        return {
          remove: function remove() {}
        };
      }

      actionSubscribers.add(handler);
      return {
        remove: function remove() {
          actionSubscribers.delete(handler);
        }
      };
    },
    dangerouslyGetParent: function dangerouslyGetParent() {
      return null;
    },
    isFirstRouteInParent: function isFirstRouteInParent() {
      return true;
    },
    _childrenNavigation: getChildrenNavigationCache(getCurrentNavigation())
  };

  var actionCreators = _objectSpread(_objectSpread({}, getNavigationActionCreators(navigation.state)), actions);

  Object.keys(actionCreators).forEach(function (actionName) {
    navigation[actionName] = function () {
      return navigation.dispatch(actionCreators[actionName].apply(actionCreators, arguments));
    };
  });
  return navigation;
}